import React from 'react';
import { ARCHIVE_LINK_VISIBLE } from '../../hooks/usePuzzleDateParam';

/**
 * The row under the countdown.
 *
 * Small text links, not buttons, and every one of them conditional. Four
 * buttons here would be a wall at the exact moment the player is deciding
 * whether this game is part of their day; in practice one or two render.
 *
 * "Play yesterday" is gated on ARCHIVE_LINK_VISIBLE along with the rest of the
 * archive. This is the strongest place to put it — someone who has just
 * finished and wants more is a better audience than someone deciding whether
 * to start — so it is worth revisiting when the archive question is settled.
 */
const SecondaryActions = ({
  canPlayYesterday,
  onPlayYesterday,
  canInstall,
  onInstall,
  canNotify,
  onNotify,
}) => {
  const actions = [];

  if (ARCHIVE_LINK_VISIBLE && canPlayYesterday) {
    actions.push({ key: 'yesterday', label: "Play yesterday's", onClick: onPlayYesterday });
  }
  if (canInstall) {
    actions.push({ key: 'install', label: 'Add to home screen', onClick: onInstall });
  }
  if (canNotify) {
    actions.push({ key: 'notify', label: 'Remind me daily', onClick: onNotify });
  }

  if (actions.length === 0) return null;

  return (
    <div className="summary-secondary">
      {actions.map((action, i) => (
        <React.Fragment key={action.key}>
          {i > 0 && <span className="summary-secondary-sep" aria-hidden="true">·</span>}
          <button type="button" className="summary-secondary-link" onClick={action.onClick}>
            {action.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SecondaryActions;
